interface DurableOAuthNavigationOptions<Session> {
  persistDraft: () => Promise<unknown>
  beginNavigation: () => void
  signIn: () => Promise<Session | null>
  cancelNavigation: () => void
}

export async function startDurableOAuthNavigation<Session>({
  persistDraft,
  beginNavigation,
  signIn,
  cancelNavigation,
}: DurableOAuthNavigationOptions<Session>): Promise<Session | null> {
  await persistDraft()
  beginNavigation()
  try {
    const session = await signIn()
    if (session) cancelNavigation()
    return session
  } catch (error) {
    cancelNavigation()
    throw error
  }
}
